import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AdminLayout from "../components/layouts/admin/AdminLayout";
import SystemConfigurations from "../screens/system-configuration/SystemConfiguration";
import ContentManagement from "../screens/content-management/ContentManagement";
import LookupListView from "../screens/lookup/LookupListView";
import FirmListView from "../screens/firm/FirmListView";
import MeasurementFieldListView from "../screens/measurement-field/MeasurementFieldListView";
import MeasurementTypeListView from "../screens/measurement-type/MeasurementTypeListView";
import GalleryDirectoryListView from "../screens/gallery-directory/GalleryDirectoryList";
import GalleryDirectoryItemList from "../screens/gallery-item/GalleryItemList";
import BranchList from "../screens/branch/BranchList";

import { routePublic } from "./PublicRoutePath";
import PageNotFound from "../components/PageNotFound";
import HSNCodeView from "../screens/hsn-sac-code/HSNCodeView";
import ClaimGroupView from "../screens/claim-group/CliamGroupView";
import ClaimGroupForm from "../screens/claim-group/ClaimGroupForm";
import RolesView from "../screens/roles/RolesView";
import RoleForm from "../screens/roles/RoleForm";
import AddressView from "../screens/address/AddressView";
import TaxCategoryView from "../screens/tax-category/TaxCategoryView";
import TaxComponentsView from "../screens/tax-components/TaxComponentsView";
import TaxGroupsView from "../screens/tax-groups/TaxGroupsView";
import PaymentTransactionView from "../screens/payment-transaction/PaymentTransactionView";
import FirmPurchasedSubscriptionView from "../screens/firm-purchased-subscription/FirmPurchasedSubscriptionView";
import SubscriptionPackageView from "../screens/subscription-package/SubscriptionPackageView";
import ExpensesView from "../screens/expenses/ExpensesView";
import DashboardView from "../screens/dashboard/DashboardView";
import HelpCategory from "../screens/help-category/HelpCategoryView";
import HelpTopics from "../screens/help-topics/HelpTopicsView";

const RouterHome = () => {
  const location = useLocation();

  const allRoutes = Object.values(routePublic).map((route) => `/${route}`);
  const isValidRoute = allRoutes.includes(location.pathname);

  return (
    <Routes>
      <Route path={routeMaster.admin} element={<AdminLayout />}>
        <Route path={routeAdmin.dashboard} element={<DashboardView />} />
        <Route path={routeAdmin.lookup} element={<LookupListView />} />
        <Route path={routeAdmin.firm} element={<FirmListView />} />
        <Route
          path={routeAdmin.measurementField}
          element={<MeasurementFieldListView />}
        />
        <Route
          path={routeAdmin.measurementType}
          element={<MeasurementTypeListView />}
        />
        <Route
          path={routeAdmin.systemConfiguration}
          element={<SystemConfigurations />}
        />
        <Route
          path={routeAdmin.contentManagement}
          element={<ContentManagement />}
        />
        <Route
          path={routeAdmin.galleryDirectory}
          element={<GalleryDirectoryListView />}
        />
        <Route
          path={routeAdmin.galleryDirectoryItem + "/:id"}
          element={<GalleryDirectoryItemList />}
        />
        <Route path={routeAdmin.branch} element={<BranchList />} />
        <Route path={routeAdmin.hsnSacCode} element={<HSNCodeView />}></Route>
        <Route
          path={routeAdmin.claimGroup}
          element={<ClaimGroupView />}
        ></Route>
        <Route
          path={routeAdmin.claimGroupForm + "/:id?"}
          element={<ClaimGroupForm />}
        ></Route>
        <Route path={routeAdmin.roles} element={<RolesView />}></Route>
        <Route
          path={routeAdmin.rolesForm + "/:id?"}
          element={<RoleForm />}
        ></Route>
        <Route path={routeAdmin.address} element={<AddressView />}></Route>
        <Route
          path={routeAdmin.taxCategory}
          element={<TaxCategoryView />}
        ></Route>
        <Route
          path={routeAdmin.taxComponents}
          element={<TaxComponentsView />}
        ></Route>
        <Route path={routeAdmin.taxGroups} element={<TaxGroupsView />}></Route>
        <Route
          path={routeAdmin.paymentTransaction}
          element={<PaymentTransactionView />}
        ></Route>
        <Route
          path={routeAdmin.firmPurchasedSubscription}
          element={<FirmPurchasedSubscriptionView />}
        ></Route>
        <Route
          path={routeAdmin.subscriptionPackage}
          element={<SubscriptionPackageView />}
        ></Route>
        <Route path={routeAdmin.expenses} element={<ExpensesView />}></Route>
        <Route
          path={routeAdmin.helpCategory}
          element={<HelpCategory />}
        ></Route>
        <Route path={routeAdmin.helpTopics} element={<HelpTopics />}></Route>
      </Route>

      {!isValidRoute && <Route path="*" element={<PageNotFound />} />}
    </Routes>
  );
};

export default RouterHome;

export const routeMaster = {
  admin: "admin",
};

export const routeAdmin = {
  dashboard: "dashboard",
  lookup: "lookup",
  firm: "firm",
  measurementField: "measurement-field",
  measurementType: "measurement-type",
  systemConfiguration: "system-settings",
  contentManagement: "content-management",
  galleryDirectory: "gallery-directory",
  galleryDirectoryItem: "gallery-directory-item",
  branch: "branches",
  taxation: "taxation",
  hsnSacCode: "taxation-hsn-sac-code",
  claimGroup: "role-permission-claim-group",
  claimGroupForm: "claim-group-form",
  roles: "role-permission-roles",
  rolesForm: "role-form",
  address: "address",
  taxCategory: "taxation-tax-category",
  taxComponents: "taxation-tax-components",
  taxGroups: "taxation-tax-groups",
  paymentTransaction: "payment-transaction",
  firmPurchasedSubscription: "firm-purchased-subscription",
  subscriptionPackage: "subscription-package",
  expenses: "expenses",
  helpCategory: "help-category",
  helpTopics: "help-topics",
};
